import t from 'tcomb';
import UUID from './UUID';
import Purchase_State from './Purchase_State';
import Datetime from './Datetime';
import Currency from './Currency';
import Amount from './Amount';

const Short_Purchase = t.struct({
  id: UUID,
  status: Purchase_State,
  tick: Datetime,
  product: t.Str,
  currency: Currency,
  amount: Amount
}, 'Short_Purchase');

module.exports = Short_Purchase;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Short_Purchase.js
 **/